import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowInventoryPreviewTemplate } from "themes/application/facility-order-new-flow-inventory/pages";
import { FacilityOrderNewFlowInventoryPreviewViewStore } from "application/facility-order-new-flow-inventory/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowInventoryPreviewViewStore(rootStore), "facilityOrderNewFlowInventoryPreviewViewStore")
@observer
class FacilityOrderNewFlowInventoryPreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowInventoryPreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowInventoryPreview;